import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":""}},[_c(VRow,{attrs:{"justify":"center","align":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_c(VIcon,[_vm._v("home")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }